/**
 * Returns a slash for the end of URLs if trailing slashes are enabled
 * @returns string
 */
export const getTrailingSlash = (): string => {
  return process.env.NEXT_PUBLIC_TRAILING_SLASH_ENABLED?.toLowerCase() == 'false' ? '' : '/';
};
